import utility from "core/Utils";
import { useEffect, useRef } from "react";
import { useState } from "react";
import Input from "./Input";

const DateInputRe = props => {
  const [dateValue, setDateValue] = useState(props.value ? props.value : "");
  const dateRef = useRef(null);

  const handleChange = e => {
    const selectedDate = e.target.value;
    setDateValue(selectedDate);

    if (props.onChange !== undefined) {
      try {
        props.onChange(selectedDate);
      } catch (error) {
        console.warn(`onChange not provided on DateInput`);
      }
    }

    // Additional validation: Ensure "to" date is greater than "from" date
    if (props.fromDate && selectedDate < props.fromDate) {
      props.onInvalidDate && props.onInvalidDate();
      props.onClearToDate && props.onClearToDate();
      // props.onInvalidDate();
      // props.onClearToDate();
    }
  };

  useEffect(() => {
    if (props.value !== dateValue) {
      setDateValue(props.value || "");
    }
  }, [props.value]);

  return (
    <div className="spot-date-input" style={{width:"45%"}}>
      <input
        type="date"
        ref={dateRef}
        value={dateValue}
        onChange={handleChange}
        min={props.min ? props.min : ""}
        max={props.max ? props.max : ""}
      />
      <Input
        disabled={props.disabled ? true : false}
        type="text"
        value={
          dateValue.length
            ? props.customFormat
              ? props.customFormat(dateValue)
              : utility.formatDate(dateValue)
            : ""
        }
        onFocus={e => {
          e.preventDefault();
          dateRef.current.showPicker();
        }}
        onChange={_ => {}}
        placeholder={props.placeholder ? props.placeholder : ""}
      />
    </div>
  );
};

export default DateInputRe;
